<template>
  <div class="footer">
    <p>This application was created for the sole intention of applying for the Senior Designer position at HEY/BaseCamp.</p>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>
